import { CUSTOM_CELL_VALUE_GETTER as n, CUSTOM_CELL_VALUE_SETTER as E } from "./index.es594.js";
const T = (r, t) => {
  const o = n[t], a = E[t];
  return { valueGetter: o ? (e) => o(e, r) : void 0, valueSetter: a ? (e) => {
    var u, s;
    return !!((s = (u = E)[t]) != null && s.call(u, e, r));
  } : void 0 };
};
export {
  T as getCustomValueSettersAndGetters
};
//# sourceMappingURL=index.es755.js.map
